// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"319": "2619777e","366": "9154912f","512": "0a480509","985": "482cb750",}[chunkId] + ".css"
}